import React, { createContext, useContext, useEffect, useReducer } from 'react';

const LOGIN_STORAGE_KEY = 'yld';

function loadPersistedState() {
  try {
    const stored = localStorage.getItem(LOGIN_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed.payload ?? parsed;
    }
  } catch (_) {}
  return null;
}

const initialData = loadPersistedState();
const initialState = null;

let reducer = (_info, newInfo) => {
  if (newInfo === null) {
    localStorage.removeItem(LOGIN_STORAGE_KEY);
    return initialState;
  }
  return newInfo;
};

const LoginResultContext = createContext();

export const LoginResultsProvider = ({ children }) => {
  const [loginResults, setloginResults] = useReducer(reducer, initialData || initialState);

  useEffect(() => {
    if (loginResults === null) {
      localStorage.removeItem(LOGIN_STORAGE_KEY);
    } else {
      localStorage.setItem(LOGIN_STORAGE_KEY, JSON.stringify({ payload: loginResults }));
    }
  }, [loginResults]);

  const updateloginResults = (results) => {
    setloginResults(results);
  };

  return (
    <LoginResultContext.Provider value={{ loginResults, updateloginResults }}>
      {children}
    </LoginResultContext.Provider>
  );
};

export const useLoginResult = () => {
  return useContext(LoginResultContext);
};





